import Seo from "@/components/site/Seo";
import { Cta } from "@/components/site/kit";

export default function NotFound() {
  return (
    <section data-testid="not-found" className="container-x flex min-h-[80vh] flex-col items-start justify-center pt-24">
      <Seo title="Page not found" noindex />
      <p className="font-score text-7xl font-bold text-[#FF5722]">404</p>
      <h1 className="mt-4 font-display text-5xl uppercase">Out of bounds</h1>
      <p className="mt-3 text-slate-400">The page you are looking for does not exist or has moved.</p>
      <div className="mt-8"><Cta to="/" testid="notfound-home-btn">Back to Home</Cta></div>
    </section>
  );
}
